import type { PropsWithChildren } from "react";
import { Container } from "react-grid-system";

import { Alert, Heading, Span, SpotIcon } from "@icg360/design-system";

import { EmailIconLink, PhoneIconLink } from "components/common/link";
import { GENERAL_SUPPORT } from "consts";
import { isBusinessHours } from "utils";

import styles from "./error-message.module.scss";

type ErrorMessageProps = PropsWithChildren<{
  message?: string;
}>;

export const ErrorMessage = ({ message, children }: ErrorMessageProps) => {
  return (
    <Container className={styles.container}>
      <div className={styles.centeredContent}>
        <div className={styles.mainIcon}>
          <SpotIcon name="RainCloudError" />
        </div>
        <Heading size="lg" className={styles.mainHeading}>
          We apologize. Something went wrong on our end.
        </Heading>
        {message && <p>{message}</p>}
        <Heading size="sm">You could try one of these options:</Heading>
        <ul className={styles.bulletedList}>
          <li>{`Wait a few minutes and try again`}</li>
          <li>{`Log in using "Incognito" or "Private" browser mode`}</li>
          <li>{`Clear the browser's cookies and cache`}</li>
        </ul>
        {children}
        <Heading size="sm">
          If none of the above works, we are here to help take a look at your
          account:
        </Heading>

        <div className={styles.contactLinks}>
          <PhoneIconLink phone={GENERAL_SUPPORT} />
          <EmailIconLink email="customercare@sagesure.com" />
        </div>
        {!isBusinessHours() && (
          <Alert
            className={styles.businessHoursAlert}
            title=""
            description={
              <>
                Our business hours are{" "}
                <Span bold>
                  Monday-Friday 8am - 9pm ET, Saturday 10am - 3pm ET
                </Span>
                . If you leave a message outside our business hours, we will get
                back to you later.
              </>
            }
          />
        )}
      </div>
    </Container>
  );
};
